import { Controller } from 'libraries/front-end-core/core/Router'
import { MW_LIST_DEALS } from 'constants/controllers'
import Header from 'components/dealwatch/header'
import Main from 'redux/containers/pages/mwlistdeals/ListDealsContainer'
import Left from 'redux/containers/pages/mwlistdeals/FilterContainer'

const searchType = 'dealwatch'

export default new Controller({
  name: MW_LIST_DEALS,
  route: '(:aol/)markets/listdeals(/:dealType)',
  controller (Router, { url: pageId, pageView, query, params: { dealType = 'all' } }, render) {
    const { q: searchPhrase, page: pageNumber = 1, pageSize = 20, parameters } = query

    render(
      { Main, Left, Header },
      {
        dealType,
        pageNumber,
        pageSize,
        parameters,
        searchPhrase,
        controller: MW_LIST_DEALS,
        pageId,
        searchType
      },
      {
        pageId,
        pageView,
        searchType,
        className: searchType,
        dealType,
        searchPhrase,
        pageNumber
      }
    )

    return pageId
  }
})
